import { render, staticRenderFns } from "./OrderSpecifics.vue?vue&type=template&id=68a84384&scoped=true"
import script from "./OrderSpecifics.vue?vue&type=script&lang=js"
export * from "./OrderSpecifics.vue?vue&type=script&lang=js"
import style0 from "./OrderSpecifics.vue?vue&type=style&index=0&id=68a84384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a84384",
  null
  
)

export default component.exports